<template>
  <div>
    <h1>Completed Payroll Requests</h1>
  
    <b-row align-h="end" class="mb-2">
      <b-col cols="auto" class="ml-auto">
          <b-button pill variant="outline-primary" @click="download">
            <b-spinner small v-show="isDownloading" class="mr-2"></b-spinner> Download All Payroll Requests
          </b-button>
      </b-col>
    </b-row>

    <b-table hover small responsive show-empty
      :fields="fields"
      :items="requests"
      :busy="isLoading">
            <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="editItem(row.item)" class="mr-1">
                edit
                </b-button>
            </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template #table-caption></template>
      <template v-slot:empty="scope">
        <p>No leave requests found.</p>
      </template>

      <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
          <strong>Loading, Please Wait...</strong>
      </div>        

    </b-table>
  </div>
</template>

<script>
import axios from 'axios';
import axiosRetry from 'axios-retry';
import fileDownload  from 'js-file-download'
import pageTitle from '@/mixins/pageTitle'

axiosRetry(axios, { retries: 3,
                    retryDelay: axiosRetry.exponentialDelay  });

export default {
  title: 'Completed Payroll Requests',
  data: () => ({
    fields: [
      {key: 'mdhTrackingId', sortable: true, label: 'Number'},
      {key: 'division', sortable: true, label: 'Division'},
      {key: 'effectiveStartDate', sortable: true, label: 'Effective Start Date'},
      {key: 'requestStatus', sortable: true, label: 'Lifecycle Status'},
      {key: 'statusLastDateTime', sortable: true, label: 'Status Date'},
      {key: 'lastUpdatedDateTime', sortable: true, label: 'Last Updated Date'},
      {key: 'employeeName', sortable: true, label: 'Employee Name'},
      {key: 'effectiveStartDate', sortable: true, label: 'Effective Start Date'},
      {key: 'supervisorName', sortable: true, label: 'Supervisor'},
      {key: 'assignedName', sortable: true, label: 'Assigned To'},
      {key: 'actions', label: 'Actions'},
    ],
    isLoading: false,
    isDownloading: false,
    requests: [],
  }),

  watch: {
    requests() {
      this.isLoading = false
    },
  },
  mixins: [
    pageTitle
  ],
  created () {
    this.initialize()
  },

  methods: {
    fetchRequests(type) {
        this.isLoading = true;
        let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/payroll/completedrequests`
        axios.get(fullUrl)
          .then(response => {
              this.requests = response.data;
              this.isLoading = false;
          })
    },

    initialize () {
      this.fetchRequests('close')
    },

    download() {
      this.isDownloading = true
      let requestConfig = {
        responseType: 'blob'       
      }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}/export/payroll`,requestConfig)
          .then(response => {
              fileDownload(response.data, 'payroll-requests.xlsx')
            this.isDownloading = false
          })
    },

    editItem(item) {
      this.$router.push({ name: 'view', params: { id: item.id } })
    },
  }
}
</script>